var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Update@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Modal---Update",
    transform: "translate(-764.000000, -518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(417.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Update",
    transform: "translate(347.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5B65DC",
    cx: 36.5,
    cy: 36.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(19.000000, 20.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "15.7857143 21.8571429 18.2142857 21.8571429 18.2142857 0 15.7857143 0 15.7857143 21.8571429"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "34 34 34 31.5714286 0 31.5714286 0 34 34 34"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.11642857 12.6164286 17 25.5 29.8835714 12.6164286 28.1592857 10.9042857 17 22.0635714 5.84071429 10.9042857"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.b133adb6e2a1df4dfbd985d263bd5c57.svg";
export { ForwardRef as ReactComponent };